export default "__VITE_ASSET__B5Tf8zSy__"